<template>
  <div
    id="exclusion-section"
    class="grid-container"
  >
    <div class="exclusions-section lh-element-topborder padding-top-m margin-bottom-m lh-container-custom-gutters">
      <h4
        id="exclusions-title"
        class="margin-bottom-s"
      >
        {{ TITLE }}
      </h4>
      <div class="grid-x exclusions-content padding-bottom-xs">
        <!-- eslint-disable-next-line vue/no-v-html -->
        <!-- Content is sourced from trusted internal configuration (config.mjs) and contains static legal text. -->
        <div
          class="medium-6 small-12 medium-padding-right-s small"
          v-html="column1Content"
        ></div>
        <!-- eslint-disable-next-line vue/no-v-html -->
        <!-- Content is sourced from trusted internal configuration (config.mjs) and contains static legal text. -->
        <div
          class="medium-6 small-12 medium-padding-left-xs small"
          v-html="column2Content"
        ></div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { computed } from 'vue';
import { EXCLUSIONS } from 'config';
import { useKillswitchesStore } from '../../stores/useKillswitchesStore';

const killswitches = useKillswitchesStore();
const { TITLE, COLUMN1_CONTENT, COLUMN2_CONTENT, COLUMN1_CONTENT_FREQUENCY_CHANGE, COLUMN2_CONTENT_ED } = EXCLUSIONS;

const column1Content = computed(() => (killswitches.blmTopOfListUpgradeEnabled ? COLUMN1_CONTENT_FREQUENCY_CHANGE : COLUMN1_CONTENT));
const column2Content = computed(() => (killswitches.triplePointsDayBenefitUpdateEnabled ? COLUMN2_CONTENT_ED : COLUMN2_CONTENT));
</script>
<style lang="scss" scoped>
.exclusions-content :deep(*) {
  color: $gray-1-color;
}
</style>
